import {
  updateFeedbacks,
  getFeedbacks,
  createFeedback,
} from "./feedback.action";
import { createSlice } from "@reduxjs/toolkit";
import { IFeedbackUI } from "./types/Feedback.interface";

const initialState: IFeedbackUI = {
  ui: { loading: false },
};

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFeedbacks.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(getFeedbacks.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.feedbacks = action.payload;
      })
      .addCase(getFeedbacks.rejected, (state) => {
        state.ui.loading = false;
      })
      .addCase(updateFeedbacks.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(updateFeedbacks.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.feedbackMessage = action.payload.message;
      })
      .addCase(updateFeedbacks.rejected, (state) => {
        state.ui.loading = false;
      })
      .addCase(createFeedback.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(createFeedback.fulfilled, (state) => {
        state.ui.loading = false;
      })
      .addCase(createFeedback.rejected, (state) => {
        state.ui.loading = false;
      });
  },
});
